import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiButtonComponent } from '../ui-button/ui-button.component';

@Component({
  selector: 'ui-success-state',
  imports: [UiButtonComponent],
  templateUrl: './ui-success-state.component.html',
  styleUrl: './ui-success-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSuccessStateComponent {
  public readonly title: InputSignal<string> = input<string>('Done');
  public readonly description: InputSignal<string | null> = input<string | null>(null);
  public readonly actionLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly actionSelected: OutputEmitterRef<void> = output<void>();

  protected readonly hasDescription: Signal<boolean> = computed((): boolean => !!this.description());
  protected readonly hasAction: Signal<boolean> = computed((): boolean => !!this.actionLabel());

  protected handleActionSelected(): void {
    this.actionSelected.emit();
  }
}
